<template>
  <div style="width: 100%;font-family: 楷体">
    <div class="div1-PCI">
      企业文化
    </div>
    <!--    第三层-->
    <div class="div3-PCI">
      <div class="div3-div-PCI">
        <div style="font-size: 20px;text-align: left">
          <br><br><br>
          可靠的质量，用心的服务！<br>
          真诚期待国内外客商光临咨询洽谈，携手共赢，共创辉煌！
          <br><br>
        </div>
        <div style="width: 100%">
          <img :src="qualityImg" alt="" width="100%">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PcCorporateCulture",
    data() {
      return {
        qualityImg:require('../../../public/image/新征程.jpg')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/computer/second/PcCorporateCulture.vue